import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import {LinearProgress} from 'material-ui/Progress'

const styles = () => ({
  VBHeaderProgress: {
    position: 'fixed',
    width: '100%',
    top: 60,
    left: 0,
    height: 3,
    zIndex: 10000,
  }
})

const HeaderProgress = ({show, classes, ...props}) => {
  if (show === false) return null
  return (
    <LinearProgress className={classes.VBHeaderProgress} color={'secondary'} {...props}/>
  )
}

HeaderProgress.propTypes = {
  show: PropTypes.bool.isRequired,
}

export default withStyles(styles)(HeaderProgress)



// WEBPACK FOOTER //
// ./src/common/components/HeaderProgress.js